import React, { Component } from "react";
import { connect } from "react-redux";
import _get from "lodash/get";
import Md5 from "md5";
import getConfig from "next/config";
import Lightbox from "react-image-lightbox";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

import { formatLocaleDate } from "@lib/helpers";

import VerifiedBuyIcon from "@components/Icons/VerifiedBuy";
import Heading from "@components/Heading";
import RatingStar from "@components/Icons/RatingStar";
import AddCommentForm from "@containers/Reviews/AddCommentForm";
import CommentItem from "@containers/Reviews/CommentItem";
import ReviewProductVariation from "@containers/Reviews/ReviewProductVariation";

import { apiCall, addAlert, addModal } from "@store/app/actions";
import {
  upvoteReviewApi,
  downvoteReviewApi,
  upvoteQuestionApi,
  downvoteQuestionApi,
  sameQuestionReviewApi,
} from "@lib/api/index";
import EditReviewModal from "@containers/Reviews/EditReviewModal";
import ModalErrorBoundary from "@containers/ModalErrorBoundary";

class ReviewItem extends Component {
  constructor() {
    super();
    this.state = {
      toggleList: false,
      toggleForm: false,
      upvoted: false,
      downvoted: false,
      photoIndex: 0,
      isOpen: false,
      customers_downvoting: [],
      customers_upvoting: [],
      sameQuestionedArray: [],
    };
    this.toggleList = this.toggleList.bind(this);
    this.toggleForm = this.toggleForm.bind(this);
  }

  componentDidMount() {
    this.setState({
      customers_downvoting: this.props.review.community.customers_downvoting,
      customers_upvoting: this.props.review.community.customers_upvoting,
      sameQuestionedArray: this.props.review.customers_sameQuestion,
    });
  }

  toggleList() {
    this.setState({
      toggleList: !this.state.toggleList,
    });
  }

  toggleForm() {
    this.setState({
      toggleForm: !this.state.toggleForm,
      // toggleList: false
    });
  }

  upvote = async (id, event) => {
    event.persist();
    if (this.props.user.isLoggedIn) {
      // first check for downvote decrement
      if (
        this.state.customers_downvoting.includes(this.props.user.customer.id)
      ) {
        await this.props.apiCall({
          spinner: true,
          alert: true,
          apiCall:
            this.props.type === "reviews"
              ? downvoteReviewApi
              : downvoteQuestionApi,
          apiArgs: [
            {
              id: id,
              communityCustomerId: this.props.user.customer.id,
              downVotes: true,
            },
          ],
          returnResponse: false,
        });
      }
      // then increment the upvote
      let res = await this.props.apiCall({
        spinner: true,
        alert: true,
        apiCall:
          this.props.type === "reviews" ? upvoteReviewApi : upvoteQuestionApi,
        apiArgs: [{ id: id, communityCustomerId: this.props.user.customer.id }],
        returnResponse: true,
        postSuccess: () => {
          this.setState({
            upvoted: true,
            downvoted: false,
          });
          this.props.addAlert({
            message: `Votul tau a fost inregistrat. Iti multumim.`,
            variant: "success",
          });
        },
      });
      // set information is state in order to have proper display of data
      this.setState({
        customers_downvoting: res.data.community.customers_downvoting,
        customers_upvoting: res.data.community.customers_upvoting,
      });
    } else {
      this.props.addAlert({
        message: `Trebuie sa fii autentificat.`,
        variant: "error",
      });
    }
  };

  downvote = async (id, event) => {
    event.persist();
    if (this.props.user.isLoggedIn) {
      // first check for upvote increment
      if (this.state.customers_upvoting.includes(this.props.user.customer.id)) {
        await this.props.apiCall({
          spinner: true,
          alert: true,
          apiCall:
            this.props.type === "reviews" ? upvoteReviewApi : upvoteQuestionApi,
          apiArgs: [
            {
              id: id,
              communityCustomerId: this.props.user.customer.id,
              downVotes: true,
            },
          ],
          returnResponse: false,
        });
      }
      // then increment the downvote
      let res = await this.props.apiCall({
        spinner: true,
        alert: true,
        apiCall:
          this.props.type === "reviews"
            ? downvoteReviewApi
            : downvoteQuestionApi,
        apiArgs: [{ id: id, communityCustomerId: this.props.user.customer.id }],
        returnResponse: true,
        postSuccess: () => {
          this.setState({
            upvoted: false,
            downvoted: true,
          });
          this.props.addAlert({
            message: `Votul tau a fost inregistrat. Iti multumim.`,
            variant: "success",
          });
        },
      });
      // set information is state in order to have proper display of data
      this.setState({
        customers_downvoting: res.data.community.customers_downvoting,
        customers_upvoting: res.data.community.customers_upvoting,
      });
    } else {
      this.props.addAlert({
        message: `Trebuie sa fii autentificat.`,
        variant: "error",
      });
    }
  };

  sameQuestion = async (id, event) => {
    event.persist();
    if (this.props.user.isLoggedIn) {
      let same = this.props.review.customers_sameQuestion.includes(
        this.props.user.customer.id
      );
      let res = await this.props.apiCall({
        spinner: true,
        alert: true,
        apiCall: sameQuestionReviewApi,
        apiArgs: [
          {
            id: id,
            communityCustomerId: this.props.user.customer.id,
            sameQuestion: same ? -1 : 1,
          },
        ],
        returnResponse: true,
        postSuccess: () => {
          this.props.addAlert({
            message: `Votul tau a fost inregistrat. Iti multumim.`,
            variant: "success",
          });
        },
      });
      // set information is state in order to have proper display of data
      this.setState({
        sameQuestionedArray: res.data.customers_sameQuestion,
      });
    } else {
      this.props.addAlert({
        message: `Trebuie sa fii autentificat.`,
        variant: "error",
      });
    }
  };

  handleEditReviewModal = () => {
    this.props.addModal(`EditReviewModal-${this.props.index}`);
  };

  render() {
    const { toggleList, toggleForm, upvoted, downvoted, photoIndex, isOpen } =
      this.state;
    const {
      type,
      review,
      user,
      // productId,
      productVariation,
      index,
      onEditReview,
    } = this.props;

    const isAddedByCurrentUser = Boolean(review.createdByCurrentUser);

    // const isBrandManager = Boolean(
    //   user.isLoggedIn && user.customer?.brand_manager
    // );

    let carouselImages = 0;
    if (type === "reviews" && review.images && review.images.length !== 0) {
      carouselImages = review.images.map(
        (item) => `${settings.cdn}/reviews-files/${review._id}/${item}`
      );
    }

    let upvoteChecked = false;
    let downvoteChecked = false;
    let sameQuestioned = false;
    if (user.customer != null) {
      upvoteChecked = this.state.customers_upvoting.includes(user.customer.id);
      downvoteChecked = this.state.customers_downvoting.includes(
        user.customer.id
      );
      if (type !== "reviews") {
        sameQuestioned = this.state.sameQuestionedArray.includes(
          user.customer.id
        );
      }
    }

    return (
      <div className="flex flex-wrap">
        <div className="md:w-1/6 md:max-w-200pxi">
          <div className="text-black font-bold mb-1 md:mb-0 inline-block">
            {review.customer.alias || review.customer.name || ""}
          </div>
          <div className="md:hidden text-gray-dark font-bold text-3xl inline-block px-2">
            .
          </div>
          <div className="mb-1 text-gray-dark font-normal md:mb-3 inline-block md:block text-sm">
            {formatLocaleDate(review.date)}
          </div>
          {review.verifiedBuyer && (
            <div className="sm:flex items-center mb-1 hidden">
              <div className="mr-1">
                <VerifiedBuyIcon />
              </div>
              <div className="leading-none">Achizitie verificata</div>
            </div>
          )}
          {productVariation && (
            <div className="hidden md:inline-block w-full">
              <ReviewProductVariation variation={productVariation} />
            </div>
          )}
        </div>

        <div className="w-full md:w-5/6 pl-0 md:pl-52px">
          <div>
            {type === "reviews" && (
              <div className="md:flex items-center mb-4">
                <div className="flex items-center md:mr-4 mb-3 md:mb-0">
                  <RatingStar
                    className={`mr-3px ${
                      review.rating >= 1 ? "text-yellow" : "text-gray-200"
                    }`}
                  />
                  <RatingStar
                    className={`mr-3px ${
                      review.rating >= 2 ? "text-yellow" : "text-gray-200"
                    }`}
                  />
                  <RatingStar
                    className={`mr-3px ${
                      review.rating >= 3 ? "text-yellow" : "text-gray-200"
                    }`}
                  />
                  <RatingStar
                    className={`mr-3px ${
                      review.rating >= 4 ? "text-yellow" : "text-gray-200"
                    }`}
                  />
                  <RatingStar
                    className={`mr-3px ${
                      review.rating >= 5 ? "text-yellow" : "text-gray-200"
                    }`}
                  />
                </div>

                {review.verifiedBuyer && (
                  <div className="flex items-center mb-1 sm:hidden">
                    <div className="mr-1">
                      <VerifiedBuyIcon />
                    </div>
                    <div className="leading-none">Achizitie verificata</div>
                  </div>
                )}
              </div>
            )}

            {productVariation && (
              <div className="inline-block md:hidden w-full mb-5">
                <ReviewProductVariation variation={productVariation} />
              </div>
            )}

            <div className="flex gap-[6px]">
              {!!review.title && (
                <div className="flex items-center gap-[5px]">
                  <Heading
                    title={review.title}
                    as="h3"
                    display="h3"
                    font="medium"
                  />
                </div>
              )}

              {type === "reviews" && isAddedByCurrentUser && (
                <div
                  onClick={() => this.handleEditReviewModal()}
                  className="text-red-brand hover:text-bleu-hover cursor-pointer"
                >
                  (editeaza recenzia)
                </div>
              )}
            </div>

            <div
              className={`break-words whitespace-pre-wrap mb-3  ${
                type === "reviews" ? "mt-2" : ""
              }`}
            >
              <p
                className={`text-gray-dark ${
                  type === "reviews" ? "" : "text-base leading-normal mt-0"
                }`}
              >
                {review.body}
              </p>
            </div>

            {/* Image tumbnail display */}
            <div className="flex items-center">
              {review.images?.length > 0 &&
                review.images.map((item, index) => (
                  <div key={index} className="mr-4">
                    <label>
                      <img
                        className="object-cover w-[48px] h-[48px] rounded-[6px]"
                        src={`${settings.cdn}/resize/reviews-files/${
                          review._id
                        }/${Md5("60x60")}/${item}`}
                        alt=""
                        onClick={() =>
                          this.setState({ isOpen: true, photoIndex: index })
                        }
                      />
                    </label>
                  </div>
                ))}
            </div>

            {isOpen && (
              <Lightbox
                mainSrc={carouselImages[photoIndex]}
                nextSrc={
                  carouselImages[(photoIndex + 1) % carouselImages.length]
                }
                prevSrc={
                  carouselImages[
                    (photoIndex + carouselImages.length - 1) %
                      carouselImages.length
                  ]
                }
                onCloseRequest={() => this.setState({ isOpen: false })}
                onMovePrevRequest={() =>
                  this.setState({
                    photoIndex:
                      (photoIndex + carouselImages.length - 1) %
                      carouselImages.length,
                  })
                }
                onMoveNextRequest={() =>
                  this.setState({
                    photoIndex: (photoIndex + 1) % carouselImages.length,
                  })
                }
              />
            )}
            <div className="flex sm:items-center flex-col sm:flex-row mt-5 ">
              <label
                htmlFor={`helpful-${type}-${review._id}`}
                className="Form-label inline-block mr-2 text-gray-text text-sm w-1/2 md:w-auto sm:mr-4"
              >
                Ti-a fost de ajutor?
              </label>

              <div className="md:w-auto sm:mr-4">
                <label className="flex">
                  <input
                    name={`helpful-${type}-${review._id}`}
                    type="radio"
                    value="da"
                    //disabled={!isLoggedIn}
                    className="checkbox-input opacity-0 w-0 h-0"
                    onChange={(event) => {
                      if (event.target.checked) {
                        this.upvote(review._id, event);
                      }
                    }}
                    checked={upvoteChecked}
                  />
                  <span
                    className="checkbox-control is-radio flex-none w-5 h-5 p-1 mr-1 md:mr-2  border-gray-light border rounded-full bg-white"
                    style={{ marginTop: "2px" }}
                  >
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="10" height="10" rx="5" fill="#319D10" />
                    </svg>
                  </span>
                  <span className="inline-block">
                    Da:{" "}
                    {_get(review, "community.upvotes", 0) + (upvoted ? 1 : 0)}
                  </span>
                </label>
              </div>

              <div className="md:w-auto">
                <label className="flex">
                  <input
                    name={`helpful-${type}-${review._id}`}
                    type="checkbox"
                    value="nu"
                    //disabled={!isLoggedIn}
                    className="checkbox-input opacity-0 w-0 h-0"
                    onChange={(event) => {
                      if (event.target.checked) {
                        this.downvote(review._id, event);
                      }
                    }}
                    checked={downvoteChecked}
                  />
                  <span className="checkbox-control mt-[2px] is-radio flex-none w-5 h-5 p-1 mr-2 border-gray-light border rounded-full bg-white">
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="10" height="10" rx="5" fill="#319D10" />
                    </svg>
                  </span>

                  <span className="inline-block">
                    Nu:{" "}
                    {_get(review, "community.downvotes", 0) +
                      (downvoted ? 1 : 0)}
                  </span>
                </label>
              </div>

              {type !== "reviews" && (
                <div className="sm:ml-4">
                  <label className="Form-checkbox flex items-center">
                    <input
                      id="same_question"
                      name="same_question"
                      type="checkbox"
                      className="checkbox-input opacity-0 w-0 h-0"
                      //disabled={!isLoggedIn}
                      onChange={(event) => {
                        if (event.target.checked) {
                          this.sameQuestion(review._id, event);
                        }
                      }}
                      checked={sameQuestioned}
                    />

                    <span className="checkbox-control is-radio flex-none inline-flex w-5 h-5 p-1 mr-2 border-gray-light border rounded-full bg-white">
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="10" height="10" rx="5" fill="#319D10" />
                      </svg>
                    </span>

                    <span className="Form-label inline-block">
                      Am aceeasi intrebare (
                      {_get(review, "sameQuestion", 0) +
                        (sameQuestioned ? 1 : 0)}
                      )
                    </span>
                  </label>
                </div>
              )}
            </div>

            {review.children.length > 0 && (
              <div className="md:flex items-center mt-1">
                <div className="my-2 md:my-0">
                  <button
                    className="text-red-brand text-sm focus:outline-none focus:underline hover:underline"
                    onClick={() => this.toggleList()}
                  >
                    {toggleList ? "Ascunde comentarii" : "Vezi comentarii"} (
                    {review.children.length})
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* COMMENTS */}
          {(toggleForm ||
            toggleList ||
            (type !== "reviews" && review.children.length > 0)) && (
            <div className="border-t border-gray-lighter mt-4 pl-4">
              {/* {toggleForm && (
                <div
                  className={`pb-6 border-gray-lighter ${
                    toggleList ? "border-b" : ""
                  }`}
                >
                  <AddCommentForm
                    closeForm={this.toggleForm}
                    productId={productId}
                    parentId={review._id}
                    type={type}
                  />
                </div>
              )} */}

              {(toggleList || type !== "reviews") && (
                <ul className="m-o p-0">
                  {review.children.map((comment, index) => (
                    <CommentItem
                      key={comment._id}
                      index={index}
                      comment={comment}
                      type={type}
                    />
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>

        {type === "reviews" && (
          <ModalErrorBoundary>
            <EditReviewModal
              modalId={`EditReviewModal-${index}`}
              review={review}
              onEditReview={onEditReview}
            />
          </ModalErrorBoundary>
        )}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    user: state.user,
  }),
  {
    apiCall,
    addAlert,
    addModal,
  }
)(ReviewItem);
